module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/verona.3570ca98a76cee7e512b5bec82fb9f02.jpg";